import React from 'react';

const GolfScoreInfo = () => {
  return (
    <ul className="inf_golf_circ">
      <li>
        <span className="circle"></span>
        <span className="circle_text">Double-Eagle</span>
      </li>
      <li className="eagle">
        <span className="circle"></span>
        <span className="circle_text">Eagle</span>
      </li>
      <li className="birdie">
        <span className="circle"></span>
        <span className="circle_text">Birdie</span>
      </li>
      <li className="par">
        <span className="circle"></span>
        <span className="circle_text">Par</span>
      </li>
      <li className="bogey">
        <span className="circle"></span>
        <span className="circle_text">Bogey</span>
      </li>
      <li className="dou_bogey">
        <span className="circle"></span>
        <span className="circle_text">Double-Bogey</span>
      </li>
      <li className="three_bagey">
        <span className="circle"></span>
        <span className="circle_text">3+ Bogey</span>
      </li>
    </ul>
  );
};

export default GolfScoreInfo;
